import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';
// import { Injectable } from '@angular/core';
// import { HttpClient } from '@angular/common/http'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  envName = environment.name;
  title = 'JLIVEX';

  // constructor( private http:HttpClient){}

  // getUser(){
  //   return this.http.get(`${this.envName}`)
  // }
}
